<app-preloader></app-preloader>
<div class="h-100" [class]="platformClass">
  <div class="app-wrapper" [class]="simulateClass">
    <app-simulate-bar (simulateClassChange)="onSimulateClassChange($event)"> </app-simulate-bar>
    <app-message-alert> </app-message-alert>
    <app-notifications-broadcast></app-notifications-broadcast>
    <router-outlet></router-outlet>
  </div>
</div>
